// The orderId can come from the match or the query params.
export const getOrderId = ({ match, location }) => {
  return parseInt(match?.params?.orderId || location?.query?.order_id) || null
}

export const orderConfirmationPaths = [
  "thank-you/",
  "order/:orderId(\\d+)/thank-you/"
]

export const getPrefixedOrderConfirmationPaths = (prefix) =>
  orderConfirmationPaths.map((path) => `${prefix}${path}`)

export const withPrefixedOrderConfirmationPaths = (prefix) => [
  prefix,
  ...getPrefixedOrderConfirmationPaths(prefix)
]
